// Shared look of a selected list filter: tinted with the foreground colour so
// it darkens in light mode and lightens in dark mode. Applied on top of the
// "ghost" button variant (cn/tailwind-merge resolves the background conflicts).
export const FILTER_SELECTED_CLASS =
  "bg-foreground/10 hover:bg-foreground/15 dark:bg-foreground/15 dark:hover:bg-foreground/20 font-semibold text-foreground";
